export default "varying vec2 lUv;\n\nvoid main() {\n    lUv = uv;\n    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n}";